/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileSizeDistributionItem
 */
export interface FileSizeDistributionItem {
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    percent: number;
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    average: number;
    /**
     * 
     * @type {number}
     * @memberof FileSizeDistributionItem
     */
    total: number;
}

export function FileSizeDistributionItemFromJSON(json: any): FileSizeDistributionItem {
    return FileSizeDistributionItemFromJSONTyped(json, false);
}

export function FileSizeDistributionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileSizeDistributionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'min': json['min'],
        'max': json['max'],
        'count': json['count'],
        'percent': json['percent'],
        'average': json['average'],
        'total': json['total'],
    };
}

export function FileSizeDistributionItemToJSON(value?: FileSizeDistributionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min': value.min,
        'max': value.max,
        'count': value.count,
        'percent': value.percent,
        'average': value.average,
        'total': value.total,
    };
}


